import { useLocation, useParams } from '@tanstack/react-router';
import type { ViewMode } from '../../../types/api';

export function useNavigationMode() {
  const location = useLocation();
  const params = useParams({ strict: false });

  // Derive current mode from pathname (includes /read/:id child routes)
  const getCurrentMode = (): ViewMode => {
    const pathname = location.pathname;
    if (pathname === '/' || pathname.startsWith('/read/')) return 'unread';
    if (pathname.startsWith('/liked')) return 'liked';
    if (pathname.startsWith('/archive')) return 'archive';
    if (pathname.startsWith('/videos')) return 'videos';
    if (pathname.startsWith('/highlights') || pathname.startsWith('/notes'))
      return 'highlights';
    if (pathname.startsWith('/folder/')) return 'folder';
    if (pathname.startsWith('/tags/')) return 'tags';
    // Search is its own section with no sidebar selection; return a mode that
    // matches none of the primary nav items so nothing appears active.
    if (pathname.startsWith('/search')) return 'search';
    return 'unread';
  };

  const mode = getCurrentMode();
  const currentFolderRouteId =
    mode === 'folder' ? (params?.folderId as string | undefined) : undefined;
  const currentTagSlug =
    mode === 'tags' ? (params?.slug as string | undefined) : undefined;

  return {
    mode,
    currentFolderRouteId,
    currentFolderHasSlug: mode === 'folder' && params?.slug !== undefined,
    currentTagSlug,
  };
}
